export default "__VITE_ASSET__D2KS42fT__"